import { useState } from 'react'

export type Params = {
  debug?: boolean
  name?: string
}

const useModal = ({ debug = false, name = 'no name specified' }: Params = {}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const handleOpen = () => {
    if (debug) {
      // eslint-disable-next-line no-console
      console.info('opening modal: ', { name })
    }
    window.document.body.classList.add('_overflow-hidden')
    setIsModalOpen(true)
  }

  const handleClose = () => {
    if (debug) {
      // eslint-disable-next-line no-console
      console.info('closing modal: ', { name })
    }

    window.document.body.classList.remove('_overflow-hidden')
    setIsModalOpen(false)
  }

  return { isModalOpen, handleOpen, handleClose }
}

export default useModal
